import AmerikolayHome from "./AmerikolayHome";
import { KnowledgeArticlePage, KnowledgeHub } from "./KnowledgePages";
import { KNOWLEDGE_BASE_PATH, findArticleByPath } from "./content/articles";

function normalizePath(pathname: string) {
  if (pathname === "/") return pathname;
  return `${pathname.replace(/\/+$/, "")}/`;
}

export function createAmerikolayApp(pathname: string) {
  const normalized = normalizePath(pathname);
  const article = findArticleByPath(normalized);

  if (article) return <KnowledgeArticlePage article={article} />;
  if (normalized === KNOWLEDGE_BASE_PATH) return <KnowledgeHub />;
  return <AmerikolayHome />;
}
